import React, { useEffect, useState } from 'react';

const DatabaseStats = ({ stats }) => {
    const [animateStats, setAnimateStats] = useState(false);
    
    useEffect(() => {
      setAnimateStats(true);
      const timer = setTimeout(() => setAnimateStats(false), 1000);
      return () => clearTimeout(timer);
    }, [stats]);
  
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8">
        <div className={`bg-dark-600 rounded-2xl p-5 transition-all duration-500 ${animateStats ? 'transform scale-105' : ''}`}>
          <h4 className="text-gray-400 text-sm mb-2">Total Accounts</h4>
          <p className="text-3xl font-bold">{stats.totalAccounts || 'N/A'}</p>
          <div className="flex items-center mt-1">
            <span className="text-accent-green text-xs">+42K this week</span>
          </div>
        </div>
        <div className={`bg-dark-600 rounded-2xl p-5 transition-all duration-500 ${animateStats ? 'transform scale-105 delay-100' : ''}`}>
          <h4 className="text-gray-400 text-sm mb-2">Unique Passwords</h4>
          <p className="text-3xl font-bold">{stats.uniquePasswords || 'N/A'}</p>
          <div className="flex items-center mt-1">
            <span className="text-accent-blue text-xs">Common: 145K</span>
          </div>
        </div>
        <div className={`bg-dark-600 rounded-2xl p-5 transition-all duration-500 ${animateStats ? 'transform scale-105 delay-200' : ''}`}>
          <h4 className="text-gray-400 text-sm mb-2">Server Sources</h4>
          <p className="text-3xl font-bold">{stats.serverSources || 'N/A'}</p>
          <div className="flex items-center mt-1">
            <span className="text-accent-purple text-xs">Recent: 124</span>
          </div>
        </div>
        <div className={`bg-dark-600 rounded-2xl p-5 transition-all duration-500 ${animateStats ? 'transform scale-105 delay-300' : ''}`}>
          <h4 className="text-gray-400 text-sm mb-2">Success Rate</h4>
          <p className="text-3xl font-bold">{stats.successRate || 'N/A'}</p>
          <div className="flex items-center mt-1">
            <span className="text-accent-orange text-xs">Premium: 82%</span>
          </div>
        </div>
      </div>
    );
  };

export default DatabaseStats;